import Highcharts from "highcharts";
import { useEffect } from "react";

import { OptionsBubbleSeries, OptionsScatterSeries } from "store/slice/charts/chartsSlice.types";

const useCustomiseLabels = (
    showRoles: boolean,
    showNames: boolean,
    setChartOptions:
        | React.Dispatch<React.SetStateAction<OptionsBubbleSeries>>
        | React.Dispatch<React.SetStateAction<OptionsScatterSeries>>,
    legendSelected: number[],
    showAllLabels?: boolean,
    hideAllLabels?: boolean,
    isSwitchAllLabelsEnabled?: boolean
): void => {
    useEffect(() => {
        //@ts-ignore
        setChartOptions((options: OptionsBubbleSeries | OptionsScatterSeries | Highcharts.Options) => {
            const { series, plotOptions, ...restOptions } = options;

            const updatedPlotOptions = { ...options.plotOptions };
            if (updatedPlotOptions?.series && updatedPlotOptions.series.dataLabels && isSwitchAllLabelsEnabled) {
                if (Array.isArray(updatedPlotOptions.series.dataLabels)) {
                    updatedPlotOptions.series.dataLabels.map((label) => (label.allowOverlap = showAllLabels));
                } else {
                    updatedPlotOptions.series.dataLabels.allowOverlap = showAllLabels;
                }
            }

            const newSeries = series
                ? //@ts-ignore
                  series.map(({ data, type, ...restSerieOptions }, index) => {
                      const customData = data?.[0]?.custom;
                      const newName = `${showNames ? customData?.entity_name : ""} 
                        ${showNames && showRoles ? "</br>" : ""} ${showRoles ? customData?.current_job_title : ""}`;

                      const isPotentialChart = options.chart && options.chart.className === "PotentialChart";
                      return {
                          ...restSerieOptions,
                          ...(isPotentialChart ? { name: newName } : {}),
                          visible: legendSelected.includes(index) ? true : false,
                          data: data
                              ? data.map((option: Highcharts.PointOptionsObject) => {
                                    const { dataLabels, ...restPointOptions } = option;
                                    const isTeamCompetitive =
                                        options.chart && options.chart.className === "TeamCompetitiveChart";

                                    const baseDataLabels = dataLabels ?? {};
                                    const marker = restPointOptions.marker ?? {};
                                    const isPointHidden = marker.enabled === false;

                                    const custom = restPointOptions.custom ?? {};

                                    const getFormatText = (): string => {
                                        const name = custom.entity_name ?? restPointOptions.name ?? "";
                                        const role = custom.current_job_title ?? "";
                                        const tag = custom.label ?? "";

                                        if (showRoles && showNames) {
                                            return custom.entity_type === "person" ? `${name} - ${role}` : tag;
                                        }

                                        if (showRoles) {
                                            return custom.entity_type === "person" ? role : tag;
                                        }

                                        if (showNames) {
                                            return custom.entity_type === "person" ? name : tag;
                                        }

                                        return "";
                                    };

                                    return {
                                        ...restPointOptions,
                                        dataLabels: (() => {
                                            const wantsLabel = isTeamCompetitive ? showNames : showRoles || showNames;
                                            const enabled = hideAllLabels ? false : wantsLabel && !isPointHidden;

                                            return isTeamCompetitive
                                                ? { ...baseDataLabels, enabled }
                                                : { ...baseDataLabels, enabled, format: getFormatText() };
                                        })(),
                                    };
                                })
                              : undefined,
                      };
                  })
                : undefined;

            return { ...restOptions, series: newSeries, plotOptions: updatedPlotOptions };
        });
    }, [showRoles, showNames, setChartOptions, legendSelected, showAllLabels, hideAllLabels, isSwitchAllLabelsEnabled]);
};

export default useCustomiseLabels;
